module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cindy Gerard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cindy Gerard"), _c('B'), _vm._v("is the critically acclaimed "), _c('I', [_vm._v("New York Times ")]), _vm._v("and "), _c('I', [_vm._v("USA Today ")]), _vm._v("bestselling author of the wildly popular Black Ops series, the Bodyguards series, and more than thirty contemporary romance novels. Her latest books include the One-Eyed Jacks novels"), _c('I', [_vm._v(" Killing Time, Running Blind, ")]), _vm._v("and "), _c('I', [_vm._v("The Way Home. ")]), _vm._v("Her work has won the prestigious RITA Award for Best Romantic Suspense. She and her husband live in the Midwest. Visit her online at CindyGerard.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9GBai2/tc-custom/9781451606874.jpg?1730537806683",
      "alt": "This image is the cover for the book Killing Time, One-Eyed Jacks"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Killing Time, One-Eyed Jacks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("First of the One-Eyed Jack series from bestselling author Cindy Gerard, "), _c('i', [_vm._v("Killing Time")]), _vm._v(" is packed with action, romance, and the search for the truth \"in this addition to her unique and successful brand of special-ops romantic suspense\" ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _c('br'), _c('i', [_vm._v("New York Times ")]), _vm._v("and "), _c('i', [_vm._v("USA Today ")]), _vm._v("bestselling author Cindy Gerard plunges readers into the heart of a seductive contest of wills between a hard-living hero and a beautiful rogue operative who is on a mission to dig up the secrets of his past. Tension sizzles in this pulse-pounding first adventure in Gerard’s action-packed new series as Eva Salinas lures Mike Brown from the sultry streets of Lima, Peru, to the desolate Idaho wilderness on the hunt for the cold-blooded traitor behind a fatal military operation that haunts them both.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gallery\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0